// extracted by mini-css-extract-plugin
export default {"icon-animation":"KcmF7_v1sNNPETJlRClM","common_bganimation":"vopvhznOrH1p5cAUVy3r"};